import React from "react";
import { motion } from "framer-motion";
import { MemoryRouter } from "react-router-dom";
import styles from "./Legalai.module.scss";

// --- Centralized Inline SVGs ---
const Icons = {
  Check: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
    </svg>
  ),
  ArrowRight: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M5 12h14M12 5l7 7-7 7"></path>
    </svg>
  ),
  Workflow: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"></path>
      <path d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
    </svg>
  ),
  Visibility: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
    </svg>
  ),
  AI: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
    </svg>
  ),
  Mobile: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"></path>
    </svg>
  ),
  SLA: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
    </svg>
  ),
  Collab: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"></path>
    </svg>
  ),
  Lock: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
    </svg>
  ),
  Risk: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M13 17h8m0 0V9m0 8l-8-8-4 4-6-6"></path>
    </svg>
  ),
  Impact: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"></path>
    </svg>
  ),
  Bank: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"></path>
    </svg>
  ),
  Network: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"></path>
    </svg>
  ),
  User: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
    </svg>
  ),
  Document: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
      <polyline points="14 2 14 8 20 8"></polyline>
      <circle cx="10" cy="13" r="2"></circle>
      <line x1="11.4" y1="14.4" x2="15" y2="18"></line>
    </svg>
  ),
  PieChart: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path>
      <path d="M22 12A10 10 0 0 0 12 2v10z"></path>
    </svg>
  ),
  Mic: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z"></path>
      <path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>
      <line x1="12" x2="12" y1="19" y2="22"></line>
    </svg>
  ),
  Clipboard: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
      <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
    </svg>
  ),
  Settings: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <circle cx="12" cy="12" r="3"></circle>
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
    </svg>
  ),
  Clock: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <circle cx="12" cy="12" r="10"></circle>
      <polyline points="12 6 12 12 16 14"></polyline>
    </svg>
  ),
  Laptop: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
      <line x1="8" y1="21" x2="16" y2="21"></line>
      <line x1="12" y1="17" x2="12" y2="21"></line>
    </svg>
  ),
  Graph: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
    </svg>
  ),
  Shield: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
    </svg>
  ),
  Cloud: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"></path>
    </svg>
  ),
  Analyze: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 5.25l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z"></path>
    </svg>
  ),
};

// --- Animations ---
const parentVariants = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { staggerChildren: 0.1 } },
};
const childVariants = {
  hidden: { opacity: 0, y: 20 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1] },
  },
};

// --- Custom Legal AI Hero Art ---
const LegalAIHeroArt = () => (
  <div className="product-hero-art" aria-hidden>
    <div className="product-hero-art-glow" />
    <svg
      className="product-hero-svg"
      viewBox="0 0 440 380"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <filter id="hero-glow" x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur stdDeviation="8" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <linearGradient id="doc-grad-main" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#4f46e5" stopOpacity="0.8" />
          <stop offset="100%" stopColor="#0ea5e9" stopOpacity="0.2" />
        </linearGradient>
        <linearGradient id="scan-grad" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="transparent" />
          <stop offset="50%" stopColor="#38bdf8" />
          <stop offset="100%" stopColor="transparent" />
        </linearGradient>
      </defs>

      {/* Background Decorative Rings */}
      <circle
        cx="220"
        cy="190"
        r="140"
        stroke="rgba(99, 102, 241, 0.1)"
        strokeWidth="1"
        strokeDasharray="4 8"
        className="anim-spin-slow"
      />
      <circle
        cx="220"
        cy="190"
        r="100"
        stroke="rgba(14, 165, 233, 0.15)"
        strokeWidth="1"
        strokeDasharray="8 8"
        className={styles["anim-spin-reverse"]}
      />

      {/* Background Shadow Document */}
      <rect
        x="150"
        y="50"
        width="160"
        height="220"
        rx="12"
        fill="rgba(15, 23, 42, 0.6)"
        stroke="#3730a3"
        strokeWidth="1.5"
        className="anim-float"
        style={{ animationDelay: "0.5s" }}
      />

      {/* Main Focused Document */}
      <rect
        x="130"
        y="80"
        width="160"
        height="230"
        rx="12"
        fill="rgba(15, 23, 42, 0.95)"
        stroke="url(#doc-grad-main)"
        strokeWidth="2"
        className="anim-float"
      />

      {/* Document Content - Header */}
      <rect
        x="150"
        y="110"
        width="60"
        height="12"
        rx="4"
        fill="#38bdf8"
        opacity="0.8"
        className="anim-float"
      />
      <circle
        cx="260"
        cy="116"
        r="12"
        fill="rgba(99, 102, 241, 0.3)"
        stroke="#4f46e5"
        strokeWidth="1.5"
        className="anim-float"
      />

      {/* Document Content - Paragraphs */}
      <line
        x1="150"
        y1="140"
        x2="270"
        y2="140"
        stroke="#475569"
        strokeWidth="4"
        strokeLinecap="round"
        className="anim-float"
      />
      <line
        x1="150"
        y1="156"
        x2="250"
        y2="156"
        stroke="#475569"
        strokeWidth="4"
        strokeLinecap="round"
        className="anim-float"
      />
      <line
        x1="150"
        y1="172"
        x2="260"
        y2="172"
        stroke="#475569"
        strokeWidth="4"
        strokeLinecap="round"
        className="anim-float"
      />

      <line
        x1="150"
        y1="196"
        x2="270"
        y2="196"
        stroke="#475569"
        strokeWidth="4"
        strokeLinecap="round"
        className="anim-float"
      />
      <line
        x1="150"
        y1="212"
        x2="220"
        y2="212"
        stroke="#475569"
        strokeWidth="4"
        strokeLinecap="round"
        className="anim-float"
      />

      {/* AI Extraction Highlight Box */}
      <rect
        x="146"
        y="230"
        width="128"
        height="28"
        rx="6"
        fill="rgba(16, 185, 129, 0.15)"
        stroke="#10b981"
        strokeWidth="1"
        strokeDasharray="4 4"
        className="anim-pulse-box anim-float"
      />
      <line
        x1="154"
        y1="240"
        x2="260"
        y2="240"
        stroke="#10b981"
        strokeWidth="4"
        strokeLinecap="round"
        className="anim-float"
      />
      <line
        x1="154"
        y1="250"
        x2="200"
        y2="250"
        stroke="#10b981"
        strokeWidth="4"
        strokeLinecap="round"
        className="anim-float"
      />

      {/* Extracted Data Tooltips */}
      <path
        d="M274 244 L320 220"
        stroke="#10b981"
        strokeWidth="1.5"
        strokeDasharray="3 3"
        className="anim-float"
      />
      <rect
        x="320"
        y="200"
        width="100"
        height="36"
        rx="6"
        fill="rgba(16, 185, 129, 0.1)"
        stroke="#10b981"
        strokeWidth="1.5"
        className="anim-float"
        style={{ animationDelay: "0.2s" }}
      />
      <text
        x="330"
        y="217"
        fill="#10b981"
        fontSize="10"
        fontWeight="bold"
        fontFamily="monospace"
      >
        CLAUSE EXTRACTED
      </text>
      <text x="330" y="230" fill="#a7f3d0" fontSize="9" fontFamily="monospace">
        Liability: $0
      </text>

      <path
        d="M140 116 L80 140"
        stroke="#0ea5e9"
        strokeWidth="1.5"
        strokeDasharray="3 3"
        className="anim-float"
      />
      <rect
        x="10"
        y="130"
        width="70"
        height="36"
        rx="6"
        fill="rgba(14, 165, 233, 0.1)"
        stroke="#0ea5e9"
        strokeWidth="1.5"
        className="anim-float"
        style={{ animationDelay: "0.4s" }}
      />
      <text
        x="20"
        y="147"
        fill="#0ea5e9"
        fontSize="10"
        fontWeight="bold"
        fontFamily="monospace"
      >
        CONTRACT
      </text>
      <text x="20" y="160" fill="#bae6fd" fontSize="9" fontFamily="monospace">
        Verified
      </text>

      <path
        d="M190 290 L160 330"
        stroke="#a855f7"
        strokeWidth="1.5"
        strokeDasharray="3 3"
        className="anim-float"
      />
      <rect
        x="100"
        y="330"
        width="80"
        height="30"
        rx="6"
        fill="rgba(168, 85, 247, 0.1)"
        stroke="#a855f7"
        strokeWidth="1.5"
        className="anim-float"
        style={{ animationDelay: "0.7s" }}
      />
      <text
        x="110"
        y="349"
        fill="#a855f7"
        fontSize="10"
        fontWeight="bold"
        fontFamily="monospace"
      >
        RISK: LOW
      </text>

      {/* AI Scanner Bar */}
      <g className={styles["anim-scanner-complex"]}>
        <rect
          x="110"
          y="150"
          width="200"
          height="4"
          fill="url(#scan-grad)"
          filter="url(#hero-glow)"
        />
        <polygon points="120,150 115,145 115,155" fill="#38bdf8" />
        <polygon points="300,150 305,145 305,155" fill="#38bdf8" />
      </g>
    </svg>
  </div>
);

const LegalAI = () => {
  return (
    <>
      <div className="product-page">
        {/* 1. HERO SECTION */}
        <section className="product-hero-dark">
          <div className="product-hero-mesh" />
          <div className="product-hero-glow-1" />
          <div className="product-hero-glow-2" />

          <div className="sec-container">
            <div className="product-hero-row">
              <motion.div
                className="product-hero-inner"
                variants={parentVariants}
                initial="hidden"
                animate="show"
              >
                <motion.div
                  className="product-eyebrow"
                  variants={childVariants}
                >
                  <span className="product-eyebrow-dot" /> Powered by Advanced
                  AI
                </motion.div>
                <motion.h1 className="product-h1" variants={childVariants}>
                  <span className="product-text-gradient">
                    Your Intelligent
                  </span>{" "}
                  Legal Analysis Partner
                </motion.h1>
                <motion.p className="product-lead" variants={childVariants}>
                  Analyze property documents with AI precision. Generate
                  comprehensive title search reports in minutes, not days.
                </motion.p>
                <motion.div
                  className="product-cta-group"
                  variants={childVariants}
                >
                  <a
                    href="/contact"
                    className="product-btn product-btn-primary"
                  >
                    Book a Demo
                  </a>
                  {/* <a
                    href="/api-catalogue-home"
                    className="product-btn product-btn-outline"
                  >
                    Start in Sandbox
                  </a> */}
                </motion.div>
              </motion.div>

              <motion.div
                variants={parentVariants}
                initial="hidden"
                animate="show"
                style={{ flex: 1, width: "100%" }}
              >
                <LegalAIHeroArt />
              </motion.div>
            </div>
          </div>
        </section>

        {/* 2. FEATURES SECTION (6 Cards mapped to HTML content) */}
        <section className="product-section">
          <div className="sec-container">
            <motion.div
              className="product-section-head"
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              variants={childVariants}
            >
              <span className="product-section-eyebrow">Features</span>
              <h2 className="gen-h2">
                Everything you need for legal document analysis
              </h2>
              <p className="gen-h2-sub">
                Our AI-powered platform streamlines property document analysis
                with intelligent automation and precision.
              </p>
            </motion.div>

            <motion.div
              className="product-grid-3"
              variants={parentVariants}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >
              <motion.div
                className="product-card hover-glow-blue"
                variants={childVariants}
              >
                <div
                  className="product-icon-box"
                  style={{
                    background: "#eff6ff",
                    color: "#3b82f6",
                    borderColor: "#dbeafe",
                  }}
                >
                  <Icons.Clipboard />
                </div>
                <h3 className="product-card-title">Smart Document Analysis</h3>
                <p className="product-card-desc">
                  Upload property documents and let AI extract, classify, and
                  analyze critical information automatically.
                </p>
              </motion.div>

              <motion.div
                className="product-card hover-glow-orange"
                variants={childVariants}
              >
                <div
                  className="product-icon-box"
                  style={{
                    background: "#fffbeb",
                    color: "#f59e0b",
                    borderColor: "#fef3c7",
                  }}
                >
                  <Icons.Clock />
                </div>
                <h3 className="product-card-title">Title Search Reports</h3>
                <p className="product-card-desc">
                  Generate comprehensive title search reports with chain of
                  ownership, encumbrances, and legal opinions.
                </p>
              </motion.div>

              <motion.div
                className="product-card hover-glow-emerald"
                variants={childVariants}
              >
                <div
                  className="product-icon-box"
                  style={{
                    background: "#ecfdf5",
                    color: "#10b981",
                    borderColor: "#d1fae5",
                  }}
                >
                  <Icons.Settings />
                </div>
                <h3 className="product-card-title">
                  Lightning Fast Processing
                </h3>
                <p className="product-card-desc">
                  What used to take days now takes minutes. Our AI processes
                  documents at unprecedented speed.
                </p>
              </motion.div>

              <motion.div
                className="product-card hover-glow-purple"
                variants={childVariants}
              >
                <div
                  className="product-icon-box"
                  style={{
                    background: "#faf5ff",
                    color: "#a855f7",
                    borderColor: "#f3e8ff",
                  }}
                >
                  <Icons.Shield />
                </div>
                <h3 className="product-card-title">Compliance & Accuracy</h3>
                <p className="product-card-desc">
                  AI-verified analysis ensures compliance with legal standards
                  and minimises human error at every step.
                </p>
              </motion.div>

              <motion.div
                className="product-card hover-glow-blue"
                variants={childVariants}
              >
                <div
                  className="product-icon-box"
                  style={{
                    background: "#e0f2fe",
                    color: "#0ea5e9",
                    borderColor: "#bae6fd",
                  }}
                >
                  <Icons.Laptop />
                </div>
                <h3 className="product-card-title">Analytics Dashboard</h3>
                <p className="product-card-desc">
                  Track team productivity, report status, and processing metrics
                  with real-time analytics.
                </p>
              </motion.div>

              <motion.div
                className="product-card hover-glow-orange"
                variants={childVariants}
              >
                <div
                  className="product-icon-box"
                  style={{
                    background: "#fdf2f8",
                    color: "#ec4899",
                    borderColor: "#fce7f3",
                  }}
                >
                  <Icons.Graph />
                </div>
                <h3 className="product-card-title">Report Management</h3>
                <p className="product-card-desc">
                  View, edit, and manage all your generated reports with version
                  history and export options.
                </p>
              </motion.div>
            </motion.div>
          </div>
        </section>

        {/* 3. HOW IT WORKS */}
        <section
          className="product-section product-section-alt"
          id="how-it-works"
        >
          <div className="sec-container">
            <motion.div
              className="product-section-head"
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              variants={childVariants}
            >
              <span className="product-section-eyebrow">How It Works</span>
              <h2 className="gen-h2">
                Three simple steps to your legal report
              </h2>
            </motion.div>

            <motion.div
              className="product-step-wrapper"
              variants={parentVariants}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >
              <div className="product-step-line" />
              <div className="product-grid-3">
                <motion.div className="product-step" variants={childVariants}>
                  <div className="product-step-icon-wrap">
                    <div className="product-step-icon-bg" />
                    <div className="product-step-icon">
                      <Icons.Cloud />
                    </div>
                    <div className="product-step-num">1</div>
                  </div>
                  <h3 className="product-card-title">Upload Documents</h3>
                  <p className="product-card-desc">
                    Drag and drop your property documents — deeds, encumbrances,
                    tax receipts, and more.
                  </p>
                </motion.div>
                <motion.div className="product-step" variants={childVariants}>
                  <div className="product-step-icon-wrap">
                    <div className="product-step-icon-bg" />
                    <div className="product-step-icon">
                      <Icons.Analyze />
                    </div>
                    <div className="product-step-num">2</div>
                  </div>
                  <h3 className="product-card-title">AI Analysis</h3>
                  <p className="product-card-desc">
                    Our AI engine extracts key data, identifies issues, and
                    cross-references legal records.
                  </p>
                </motion.div>
                <motion.div className="product-step" variants={childVariants}>
                  <div className="product-step-icon-wrap">
                    <div className="product-step-icon-bg" />
                    <div className="product-step-icon">
                      <Icons.Document />
                    </div>
                    <div className="product-step-num">3</div>
                  </div>
                  <h3 className="product-card-title">Get Your Report</h3>
                  <p className="product-card-desc">
                    Receive a comprehensive title search report ready for review
                    and legal opinion.
                  </p>
                </motion.div>
              </div>
            </motion.div>
          </div>
        </section>

        {/* 4. STATISTICS SECTION */}
        <section className="product-section">
          <div className="sec-container">
            <div className="product-comp-grid">
              <div className="product-comp-card hover-scale">
                <p className="product-comp-val">2,847</p>
                <p className="product-comp-label">Reports Generated</p>
              </div>
              <div className="product-comp-card hover-scale">
                <p className="product-comp-val">12,541</p>
                <p className="product-comp-label">Documents Analysed</p>
              </div>
              <div className="product-comp-card hover-scale">
                <p className="product-comp-val">4.2 min</p>
                <p className="product-comp-label">Average Processing</p>
              </div>
              <div className="product-comp-card hover-scale">
                <p className="product-comp-val">99.1%</p>
                <p className="product-comp-label">Accuracy Rate</p>
              </div>
            </div>
          </div>
        </section>

        {/* 5. FINAL CTA (DARK) */}
        <section className="product-dark-cta">
          <div className="product-hero-ambient" />
          <div className="sec-container">
            <div
              className="product-cta-grid"
              style={{ gridTemplateColumns: "1fr", textAlign: "center" }}
            >
              <div style={{ maxWidth: "80rem", margin: "0 auto" }}>
                <h2 className="product-h1" style={{ fontSize: "4.8rem" }}>
                  Ready to transform your legal workflow?
                </h2>
                <p className="product-lead" style={{ marginBottom: "4rem" }}>
                  Join the platform that's redefining property document analysis
                  with the power of AI.
                </p>
                <div
                  className="product-cta-group"
                  style={{ justifyContent: "center" }}
                >
                  <a
                    href="/signup"
                    className="product-btn product-btn-primary"
                    style={{ padding: "1.6rem 3.2rem" }}
                  >
                    Get Started Free
                  </a>
                  <a
                    href="/login"
                    className="product-btn product-btn-outline"
                    style={{ padding: "1.6rem 3.2rem" }}
                  >
                    Sign In
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default LegalAI;
